const FIVE_MINUTES = 5 * 60 * 1000;
const TEN_MINUTES = 10 * 60 * 1000;

export const STALE_TIME = FIVE_MINUTES;
export const GC_TIME = TEN_MINUTES;
